import { classNames } from "@/react/helpers/twMergeWithCN";
import { useHelpWidgetContext } from "../../context/HelpWidgetContext";

interface HelpWidgetLayoutProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export const HelpWidgetLayout = ({
  children,
  className,
  id,
}: HelpWidgetLayoutProps) => {
  const { isExpanded } = useHelpWidgetContext();

  return (
    <div
      id={id}
      className={classNames(className || "", {
        "w-[736px]": isExpanded,
        "w-[400px]": !isExpanded,
      })}
    >
      {children}
    </div>
  );
};
